import { useTranslation } from "react-i18next";
import Item from "./Item";
import Title from "./Title";
export default function Certifications() {
	const { t } = useTranslation();

	return (
		<div id="certifications" className="flex-1">
			<Title>{t("certifications.title")}</Title>
			<div className="mx-auto w-3/4 grid grid-cols-2 max-xl:grid-cols-1 gap-x-10">
				<Item
					id="toeic"
					title="TOEIC"
					logo="imgs/toeic.png"
					logoClass="w-16 mb-5"
					skills={[
						t("certifications.valid"),
						"Listening: 490/495 (CEFR Level: C1)",
						<>Reading: &nbsp;470/495 (CEFR Level: C1)</>,
						<>
							Total:
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;960/990
							(CEFR Level: C1)
						</>,
					]}
				></Item>
				<Item
					id="permis"
					title={t("certifications.permis")}
					logo="imgs/car.png"
					logoClass="w-14 mb-4"
					skills={[t("certifications.vehicul")]}
				></Item>
			</div>
		</div>
	);
}
